// Limpia manteniendo números y K/k (dígito verificador)
export const cleanRut = (value: string): string => value.replace(/[^0-9kK]/g, '').toUpperCase();

export const formatRut = (value: string): string => {
  const cleaned = cleanRut(value);
  if (cleaned.length <= 1) return cleaned;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  const bodyWithDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${bodyWithDots}-${dv}`;
};

export const validateRut = (value: string): boolean => {
  const cleaned = cleanRut(value);
  if (cleaned.length < 2) return false;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1).toUpperCase();
  if (!/^\d+$/.test(body)) return false;
  let factor = 2;
  let sum = 0;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const rest = 11 - (sum % 11);
  const expected = rest === 11 ? '0' : rest === 10 ? 'K' : String(rest);
  return dv === expected;
};

export const validateNombre = (value?: string): boolean => {
  if (!value) return false;
  const v = value.trim();
  if (!v) return false;
  return /^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(v);
};

// Limita largo del RUT: hasta 9 dígitos de cuerpo + 1 DV
export const limitRutLength = (value: string, maxBody: number = 9): string => {
  const cleaned = cleanRut(value);
  if (cleaned.length === 0) return '';
  if (cleaned.length === 1) {
    // Solo cuerpo en progreso
    return cleaned.replace(/[^0-9]/g, '').slice(0, maxBody);
  }
  let body = cleaned.slice(0, -1).replace(/[^0-9]/g, '');
  let dv = cleaned.slice(-1).toUpperCase();
  body = body.slice(0, maxBody);
  dv = dv.replace(/[^0-9K]/g, '').slice(0, 1);
  return dv ? body + dv : body;
};


